import { render, staticRenderFns } from "./unbanInform.vue?vue&type=template&id=39426604&scoped=true&"
import script from "./unbanInform.vue?vue&type=script&lang=js&"
export * from "./unbanInform.vue?vue&type=script&lang=js&"
import style0 from "./unbanInform.vue?vue&type=style&index=0&id=39426604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39426604",
  null
  
)

export default component.exports